import React from "react";
import "./component-css/LearningMaterials.css";

const EnergyEfficiency = () => {
            const materials = [
            {
                title: "Energy Efficiency for a Sustainable Future",
                type: "youtube",
                link: "https://youtu.be/MRuetn53deQ",
                description:
                    "An overview of energy efficiency principles and their role in supporting sustainable development and environmentally responsible building practices."
            },
            {
                title: "Energy Efficiency Improvement Measures for Renovation of Modernist Buildings Heritage",
                type: "youtube",
                link: "https://youtu.be/aZ_0lL1YnCI",
                description:
                    "An overview of energy efficiency strategies for renovating modernist buildings while preserving their architectural heritage."
            },
            {
                title: "Unlocking the First Fuel: Energy Efficiency in Buildings Across the Western Balkans",
                type: "youtube",
                link: "https://youtu.be/kbKx3yhZtds",
                description:
                    "An overview of the role of energy efficiency in improving building performance and supporting sustainable development across the Western Balkans."
            },
            {
                title: "Driving Circularity: The Role of Energy Policy and Legislation",
                type: "youtube",
                link: "https://youtu.be/IzGTgaVCbl4",
                description:
                    "Explores how energy policies and regulations support circular economy practices and sustainability."
            }

        ];
    return (
        <div className="content-page lm-page">
            <header className="lm-header">
                <h1 className="lm-title">Energy Efficiency Learning Materials</h1>
                <p className="lm-subtitle">
                    Practical insights and videos on improving building performance,
                    reducing energy use, and advancing a low-carbon, sustainable future.
                </p>
            </header>

            <div className="lm-list">
                {materials.map((m, index) => (
                    <div key={index} className="lm-card">
                        <h3 className="lm-card-title">{m.title}</h3>

                        <p className="lm-card-desc">{m.description}</p>

                        <a
                            href={m.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="lm-card-link"
                        >
                            {m.type === "pdf" ? "📄 Open PDF" : "▶ Watch Video"}
                        </a>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default EnergyEfficiency;
